module.exports = __webpack_public_path__ + "media/images/countrysquared/tc-bcd119424103b75292076a09cd7885b4.svg";